import { useShallow } from 'zustand/react/shallow'
import { useJackpotsStore } from './jackpotsStore'

const getJackpots = () => useJackpotsStore(useShallow(state => state.jackpotsData.jackpots))
const getJackpotGameIds = () => useJackpotsStore(useShallow(state => state.jackpotsData.jackpotGameIds))
const getJackpotCurrenciesGameIds = () =>
  useJackpotsStore(useShallow(state => state.jackpotsData.jackpotCurrenciesGameIds))

export { getJackpots, getJackpotGameIds, getJackpotCurrenciesGameIds }
